import React, { useEffect, useState } from "react";
import { Image, Line } from "react-konva";
import Konva from "konva";

import BackRect from "./BackRect";

const BackGroundLayer: React.FC<{
  imageSrc: any;
  width: number;
  height: number;
  hueVal: number;
  hsvVal: number;
}> = ({ imageSrc, width, height, hueVal, hsvVal }) => {
  const [DowMap] = useState(["mon", "tue", "wed", "thu", "Fri"]);
  const [BGImg, setBG]: [
    undefined,
    React.Dispatch<React.SetStateAction<undefined>>
  ] = useState();
  const BGRef: any = React.useRef();
  const LineRef: any = React.useRef();

  useEffect(() => {
    const ImgElm: any = document.createElement("img");
    ImgElm.src = imageSrc;
    ImgElm.onload = () => {
      //一度読み込まれてから行う
      setBG(ImgElm);
    };
  }, [imageSrc]);

  useEffect(() => {
    BGRef.current.cache();
    BGRef.current.getLayer().batchDraw();
  }, [BGImg]);

  useEffect(() => {
    //スマホ画面対応
    BGRef.current.cache();
    BGRef.current.getLayer().batchDraw();
  }, [width]);

  useEffect(() => {
    LineRef.current.cache();
    LineRef.current.getLayer().batchDraw();
  }, [hsvVal]);

  return (
    <>
      <Image
        image={BGImg}
        ref={BGRef}
        filters={[Konva.Filters.HSV]}
        hue={hueVal}
        value={hsvVal}
        width={width}
        height={height}
      ></Image>

      {DowMap.map((value, index) => (
        <BackRect
          x={width / 109}
          y={height / 7 + index * (height / 5.7)}
          canvasWidth={width}
          canvasHeight={height}
          key={value}
          hue={hueVal}
          val={hsvVal}
          isWeekEnd={false}
        />
      ))}
      <BackRect
        canvasWidth={width}
        canvasHeight={height}
        x={width / 1.8}
        y={height / 21.17}
        hue={hueVal}
        val={hsvVal}
        isWeekEnd={true}
        key={1}
      />
      <BackRect
        canvasWidth={width}
        canvasHeight={height}
        x={width / 1.28}
        y={height / 21.17}
        hue={hueVal}
        val={hsvVal}
        isWeekEnd={true}
        key={2}
      />
      <Line
        x={width / 9.7}
        y={height / 7.2}
        points={[0, 0, 0, 500]}
        stroke="#de9e9a"
        strokeWidth={width / 320}
        dash={[15, 5]}
        ref={LineRef}
        filters={[Konva.Filters.HSV]}
        hue={hueVal}
        value={hsvVal}
      />
    </>
  );
};

export default BackGroundLayer;
